import React, { Component } from 'react';
import { Row, Col, Carousel, List, Select, Tag, Divider, Icon, InputNumber, Alert } from 'antd';
import { Recipe as RecipeApi } from '../../../../services/api';
import { Unit } from '../../../../components/Label';
import { FormatSeconds } from '../../../../components/Time';
import AddButton from '../grocery-list/AddButton';
import AddRecipe from '../menu/AddRecipe';
import Spinner from '../../../../components/Spinner';

export default class Recipe extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recipe: { 
                title: '',
                description: '',
                images: [],
                tags: [],
                _embedded:  { 
                    'varma:steps': { data: [] },
                }
            },
            available: true,
            portions: 4,
            customPortions: false,
            ingredients: [],
            loading: false,
            loadingIngredients: false
        };

        this.recipeApi = new RecipeApi(props);
    }

    componentDidMount() {
        const { state } = this.props.location;
        if (state && state.recipe) {
            this.setState({ recipe: state.recipe });
            this.convertIngredients(null, state.recipe);
            return;
        }
        this.fetchRecipe();
    }

    fetchRecipe = () => {
        this.setState({ loading: true });
        this.recipeApi.find(this.props.match.params.id)
            .then(res => {
                this.setState({ loading: false, recipe: res.data.data });
                this.convertIngredients(null, res.data.data);
            })
            .catch(err => {
                this.recipeApi.retry({ cb: this.fetchRecipe });
                const res = err.response;
                if (!res) {
                    return;
                }
                if (res.status === 403 || res.status === 404) {
                    this.setState({ available: false, loading: false });
                }
            });
    }

    convertIngredients = (portions, recipe) => {
        if (!portions) {
            portions = this.state.portions;
        }

        this.setState({ loadingIngredients: true });
        const data = [];
        recipe._embedded['varma:ingredients'].data.forEach(i => {
            data.push({
                ingredient_id: i.origin_id,
                ref: i.id,
                from: i.unit,
                to: i.display_unit,
                qty: i.qty
            })
        });
        
        const url = recipe._links['convert-ingredients'].href + '?portions=' + portions;
        this.recipeApi.raw().post(url, data)
            .then(res => {
                const ingredients = JSON.parse((JSON.stringify(recipe._embedded['varma:ingredients'].data)));
                if (!Object.keys(this.state.ingredients).length) {
                    let sections = {};
                    ingredients.forEach(i => {
                        res.data.data.forEach(j => {
                            if (i.id === j.ref) {
                                i.unit = j.unit;
                                i.qty = j.qty;
                            }
                        });
                        i.section = i.section === '' ? 'Övriga' : i.section;
                        if (!sections[i.section]) {
                            sections[i.section] = [];
                        }
                        sections[i.section].push(i)
                    });

                    this.setState({ ingredients: sections, loadingIngredients: false });
                } else {
                    Object.keys(this.state.ingredients).forEach(section => {
                        this.state.ingredients[section].forEach(i => {
                            const index = res.data.data.findIndex(j => j.ref === i.id);
                            if (index !== -1) {
                                i.unit = res.data.data[index].unit;
                                i.qty = res.data.data[index].qty;
                            }
                        });
                    });
                    this.setState({ ingredients: this.state.ingredients, loadingIngredients: false });
                }
            })
            .catch(_ => {
                this.recipeApi.retry({ params: [portions, recipe], cb: this.convertIngredients });
            });
    }

    handlePortionChange = (portions) => {
        if (portions === 'custom') {
            this.setState({ customPortions: true });
            return;
        }

        this.setState({ portions: portions });
        this.convertIngredients(portions, this.state.recipe);
    }

    render() {
        const { 
            recipe,
            ingredients,
            loadingIngredients,
            portions, 
            customPortions,
            loading,
            available
        } = this.state;

        recipe.portions = portions;
        if (loading) {
            return (
                <Row>
                    <Spinner loading={loading} />
                </Row>
            )
        }

        if (!available) {
            return (
                <Alert 
                    type="error"
                    message="Receptet är för närvarande inte tillgängligt."
                    showIcon
                />
            )
        }

        return (
            <div>
                <Row>
                    <h2 style={styles.title}>{recipe.title}</h2>
                    <Row type="flex" justify="start" style={styles.cookingInfo}>
                        {recipe.cooking_time > 0 && (
                            <Col>
                                <Icon style={styles.cookingInfoIcon} type="clock-circle" theme="twoTone" twoToneColor="#EF7C39" />
                                <FormatSeconds seconds={recipe.cooking_time} />
                            </Col>
                        )}
                        {recipe.degrees > 0 && (
                            <Col style={{ marginLeft: '10px' }}>
                                <Icon style={styles.cookingInfoIcon} type="fire" theme="twoTone" twoToneColor="#EF7C39" />
                                <span>{recipe.degrees}°</span>
                            </Col>
                        )}
                    </Row>
                    <Col sm={12} xs={24} className="image-container">
                        <Carousel>
                            <div>
                                {recipe.images.map(i => (
                                    <img key={i.id} src={i.url} style={styles.image} alt="Receptbild" />
                                ))}
                            </div>
                        </Carousel>
                    </Col>
                    <Col sm={12} xs={24} className="meta-container">
                        <div>
                            <p style={styles.description}>{recipe.description}</p>
                            <div>
                                {recipe.tags.map(t => <Tag key={t} color="green">{t}</Tag>)}
                            </div>

                            <Row type="flex" style={{ marginTop: '20px' }}>
                                <AddButton recipe={recipe} style={{ marginRight: '10px', marginTop: '10px' }}/>
                                <AddRecipe recipe={recipe} style={{ marginTop: '10px' }} />
                            </Row>
                            
                        </div>
                    </Col>
                </Row>
                <Divider />
                <Row className="instruction-wrapper" style={styles.instructionSection}>
                    <Col sm={6} xs={24} className="ingredient-container">
                        <h3 style={styles.subtitle}>Du behöver</h3>
                        {customPortions ? (
                            <InputNumber value={portions} onChange={v => this.setState({ portions: v })} onBlur={() => this.convertIngredients(portions, recipe)} min={1} />
                        ) : (
                            <Select 
                                value={portions} 
                                defaultValue={4} 
                                onChange={this.handlePortionChange}
                                style={styles.portions}
                            >
                                <Select.Option value={1}>1 portion</Select.Option>
                                <Select.Option value={2}>2 portioner</Select.Option>
                                <Select.Option value={3}>3 portioner</Select.Option>
                                <Select.Option value={4}>4 portioner</Select.Option>
                                <Select.Option value={5}>5 portioner</Select.Option>
                                <Select.Option value={6}>6 portioner</Select.Option>
                                <Select.Option value={7}>7 portioner</Select.Option>
                                <Select.Option value={8}>8 portioner</Select.Option>
                                <Select.Option value={9}>9 portioner</Select.Option>
                                <Select.Option value={10}>10 portioner</Select.Option>
                                <Select.Option value={11}>11 portioner</Select.Option>
                                <Select.Option value={12}>12 portioner</Select.Option>
                                <Select.Option value={13}>13 portioner</Select.Option>
                                <Select.Option value={14}>14 portioner</Select.Option>
                                <Select.Option value={15}>15 portioner</Select.Option>
                                <Select.Option value={16}>16 portioner</Select.Option>
                                <Select.Option value={17}>17 portioner</Select.Option>
                                <Select.Option value={18}>18 portioner</Select.Option>
                                <Select.Option value={19}>19 portioner</Select.Option>
                                <Select.Option value={20}>20 portioner</Select.Option>
                                <Select.Option value="custom">20+ portioner</Select.Option>
                            </Select>
                        )}
                        
                        {Object.keys(ingredients).map(section => (
                            <div key={section}>
                                <strong style={{ marginTop: '10px', display: 'block' }}>{section}</strong>
                                <List 
                                    dataSource={ingredients[section]}
                                    loading={loadingIngredients}
                                    renderItem={item => (
                                        <List.Item style={styles.ingredient}>
                                            {item.qty} <Unit format="short" type={item.unit} /> {item.title}
                                        </List.Item>
                                    )}
                                />
                            </div>
                        ))}
                        
                    </Col>
                    <Col sm={{ span: 14, push: 4}} xs={24} className="step-container">
                        <h3 style={styles.subtitle}>Gör så här</h3>
                        <ul style={styles.steps}>
                            {recipe._embedded['varma:steps'].data.map(s => (
                                <li key={s.id} style={styles.step}>
                                    <Row>
                                        <Col span="2"><span className="order-number" style={styles.order}>{s.order} </span></Col>
                                        <Col style={styles.stepDesc} span="22"><span>{s.description}</span></Col>
                                    </Row>
                                </li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            </div>
        );
    }
}

const styles = {
    title: {
        fontSize: '30px',
        marginBottom: '5px'
    },
    subtitle: {
        fontSize: '25px'
    },
    description: {
        fontSize: 20,
    },
    images: {
        width: '500px'
    },
    instructionSection: {
        marginTop: '30px'
    },
    ingredient: {
        fontSize: '18px'
    },
    steps: {
        listStyle: 'none',
        padding: 0
    },
    step: {
        fontSize: '18px',
        padding: '10px 0'
    },
    stepDesc: {
        paddingTop: '8px'
    },
    order: {
        fontSize: '35px',
        color: '#EF7C39'
    },
    portions: {
        width: '126px'
    },
    cookingInfo: {
        fontSize: '22px',
        marginBottom: '20px'
    },
    cookingInfoIcon: {
        marginRight: '7px'
    },
    image: {
        maxHeight: '430px',
        objectFit: 'cover',
        width: '100%'
    }
};


// WEBPACK FOOTER //
// ./src/screens/dashboard/components/recipe/Recipe.js